import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Row, Col, Container, Input, Button, Label, TabContent, TabPane, Nav, NavItem, NavLink,Collapse } from "reactstrap";
import {
  useEmployeeListAppraisal,
  useEnableEmployeeListAppraisal,
} from "../../../components/adminSettings/index";
import TableWithSortPagtn from "../../../components/common/TableWithSortPagtnAppraisal";
import { getEmpList } from "../../../redux/actions/employee/employee.action";
import {
  GetAppraisalEnableList,
  EnableAllAppraisee
} from "../../../redux/actions/appraisal/appraisal.action";
import Notifications from "../../../components/common/Notifications";
import Multiselect from 'multiselect-react-dropdown';
import "../../../style/adminSettings.css"
import api from "../../../apis/api";
import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components";
const AppraisalAssign = (props) => {
   
  // Store the full employee list for search reset
  const [allEmpData, setAllEmpData] = useState([]);
  const { getEmpList,GetAppraisalEnableList,EnableAllAppraisee} = props;
  const { empList } = props.empList;
  const {appraisalEnableList} = props.appraisalEnableList;
  const [empData, setEmpData] = useState([]);

  const [empArr, setempArr] = useState([]);
  const [empArr1, setempArr1] = useState([]);
  const [enableList,setEnableList] = useState([]);
  const [error, setError] = useState(null);
  const [selectstatus,setselectstatus]=useState(false);
  const [searchArr, setSearchArr] = useState([]);
  const [selMonths, setselMonths] = useState([]);
  const [enabledemployeelist,setenabledemployeelist] =useState([]);
    const [activeTab, setActiveTab] = useState("1");
const [selectedEmpAppraisal, setSelectedEmpAppraisal] = useState([]);
const [selectedEmpOngoing, setSelectedEmpOngoing] = useState([]);
// ✅ SWITCH SELECTION BASED ON TAB
  const selectedEmp =
    activeTab === "1" ? selectedEmpAppraisal : selectedEmpOngoing;

  const setSelectedEmp =
    activeTab === "1"
      ? setSelectedEmpAppraisal
      : setSelectedEmpOngoing;

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setSearchArr([]);

  
    }
  };

    // const toggle = (tab) => {
    //   if (activeTab !== tab) {
    //     setActiveTab(tab);
    //     setSearchArr([]); // Reset search results when switching tabs
    //   }
    // };
  let emparray=[];
  let selectedoptionsList=[]; 
  let options=[];
   options.push({value: "January", label: "January" },
    {value: "February", label: "February" },
    {value: "March", label: "March" },
    {value: "April", label: "April" },
    {value: "May", label: "May" },
    {value: "June", label: "June"},
    {value: "July", label: "July" },
    {value: "August", label: "August" },
    {value: "September", label: "September" },
    {value: "October", label: "October" },
    {value: "November", label: "November" },
    {value: "December", label: "December" },
    {value: "0", label: "Not Eligible" }
   );
const [loaded, setLoaded] = useState(false);
   
const DarkBackground = styled.div`
display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
${(props) =>
  props.disappear &&
  css`
    display: block; /* show */
  `}
`;
  const [thead] = useState([
    "Select",
    "Id",
    "Code",
    "Name",
    "EligibilityStatus",
    "JoiningDate",
    // "DueOn",
    "LastReview",
    "Reviewer1",
    "Reviewer2"
  ]);
  const [thead1] = useState([
    "Select",
    "Id",
    "Code",
    "Name",
    "EligibilityStatus",
    "JoiningDate",
    // "DueOn",
    "LastReview",
    "Status",
    "Reviewer1",
    "Reviewer2",
    "Action"
  ]);
  useEffect(() => {
    getEmpList();
    GetAppraisalEnableList();
  }, [getEmpList,GetAppraisalEnableList]);

  useEffect(()=>{
    let array=[];
   setempArr(
  empList.filter(emp => emp.value?.isActive === true || emp.value?.isActive === "true")
);
    const uniqueAppraisalList = appraisalEnableList?.length ? appraisalEnableList.filter((v, i, a) => a.findIndex(t => (t.employeeId === v.employeeId)) === i) : [];
    setempArr1(uniqueAppraisalList)
    setEnableList(uniqueAppraisalList)
    const fetchApi =async()=>{
      await api.appraisal().GetAppraisalEnabledEmployeeList().then((res) => array.push(res.data));
      const uniqueEnabledList = array[0]?.length ? array[0].filter((v, i, a) => a.findIndex(t => (t.employeeId === v.employeeId)) === i) : [];
      setenabledemployeelist(uniqueEnabledList);
    }
    fetchApi();
  },[empList,appraisalEnableList,setenabledemployeelist])

  // custome hook.
  //const { empArr } = useForTableValues(empList, projectList);

  useEffect(() => {
  const uniqueList = appraisalEnableList?.length ? appraisalEnableList.filter((v, i, a) => a.findIndex(t => (t.employeeId === v.employeeId)) === i) : [];
  setEmpData(uniqueList);
  setAllEmpData(uniqueList);
  }, [appraisalEnableList]);
 
  //   Function....
  // search employee by name.
  const searchEmployee = React.useCallback(
    (searchVal) => {
      let tempArr = [];
      if (searchVal !== "") {
        // Always search from the full list
        let listToSearch = activeTab === "1"
          ? allEmpData // eligible employees in Appraisal tab
          : enabledemployeelist; // enabled employees in OnGoing Appraisal tab

        listToSearch?.forEach((el) => {
          if (el.employeeName && el.employeeName.toLowerCase().includes(searchVal.toLowerCase())) {
            if (!tempArr.includes(el)) tempArr.push(el);
          }
        });
        if (activeTab === "1") {
          setEmpData(tempArr);
        } else {
          // For OnGoing Appraisal tab, update enabledemployeelist for search
          setEmpData(enabledemployeelist); // always keep empData as enabledemployeelist for table
          setSearchArr(tempArr); // use searchArr for filtered rows
        }
      } else {
        // Reset to full list based on activeTab
        if (activeTab === "1") {
          setEmpData(allEmpData);
        } else {
          setEmpData(enabledemployeelist);
          setSearchArr([]);
        }
      }
    },
    [activeTab, allEmpData, enabledemployeelist]
  );

  //   append to arr selected employee.
  const handleSelectedEmp = React.useCallback((emp) => {
    let filterEmp = selectedEmp.filter((el)=>el.employeeId == emp.employeeId);
    if(filterEmp.length == 0){
      setSelectedEmp((precState) => [...precState, emp]);
    }
    
  }, [selectedEmp]);

  // handle select all employee.
  const handleSelectAllEmp = React.useCallback(
    (e) => {
      //console.log(e.target.checked);
      let checkBox = e.target.checked;
      let tempArr = [];
      if (checkBox) {
        empData.map((employee) =>
        tempArr.push({
          designationName:employee.designationName,
          employeeId:employee.employeeId,
          employeeName:employee.employeeName,
          isEnabled:true,
          profilePicture:employee.profilePicture,
          reviewer1:employee.reviewer1,
          reviewer2:employee.reviewer2
        })

        );
        setSelectedEmp(tempArr);
        // setEmpData(tempArr);
      } else {

        empData.map((employee) =>
        tempArr.push({
          designationName:employee.designationName,
          employeeId:employee.employeeId,
          employeeName:employee.employeeName,
          isEnabled:false,
          profilePicture:employee.profilePicture,
          reviewer1:employee.reviewer1,
          reviewer2:employee.reviewer2
        })

        );
        setSelectedEmp(empData);
      //  setEmpData(empData);
      }
    },
    [empData,setSelectedEmp,selectedEmp,setEmpData]
  );

  const handleClick = React.useCallback(async () => {
    setLoaded(true);

  const payload = empData
    .filter(emp => emp.isEnabled === true &&
    !enabledemployeelist.some(e => e.employeeId === emp.employeeId))
    .map(emp => ({
      employeeId: emp.employeeId,
      reviewer1: emp.reviewer1 || null,
      reviewer2: emp.reviewer2 || null,
      isEnabled: true
    }));

  if (payload.length === 0) {
    setError({ message: "Please choose any employee..", status: 500 });
    setLoaded(false);
    return;
  }
    if (selectstatus === true) {
      const fetchApi = async () => {
        await EnableAllAppraisee(payload);
        // Only after enabling, re-fetch both employee list and enabled appraisal list
        await getEmpList();
        await GetAppraisalEnableList();
        const res = await api.appraisal().GetAppraisalEnabledEmployeeList();
        const uniqueEnabledList = res.data?.length ? res.data.filter((v, i, a) => a.findIndex(t => t.employeeId === v.employeeId) === i) : [];
        setenabledemployeelist(uniqueEnabledList);
        setEmpData(uniqueEnabledList); // Use the latest data for table
        let array = [];
        setempArr(
          empList.filter(emp => emp.value?.isActive === true || emp.value?.isActive === "true")
        );
        const uniqueAppraisalList = appraisalEnableList?.length ? appraisalEnableList.filter((v, i, a) => a.findIndex(t => t.employeeId === v.employeeId) === i) : [];
        setempArr1(uniqueAppraisalList);
        setEnableList(uniqueAppraisalList);
        await api.appraisal().GetAppraisalEnabledEmployeeList().then((res) => array.push(res.data));
        const uniqueEnabledList2 = array[0]?.length ? array[0].filter((v, i, a) => a.findIndex(t => t.employeeId === v.employeeId) === i) : [];
        setenabledemployeelist(uniqueEnabledList2);
        setEmpData(uniqueAppraisalList);
        // Reset all local UI state to initial values
        setError({ ...error, message: "Appraisal Enabled Successfully..", status: 200 });
      };
      fetchApi();
    } else {
      setError({ ...error, message: "Please choose any employee..", status: 500 });
    }
    setTimeout(() => {
      setLoaded(false);
    }, 10000);
  }, [empData, selectstatus, empList, GetAppraisalEnableList, appraisalEnableList, getEmpList, setempArr, setEmpData, setLoaded, setenabledemployeelist, setSelectedEmp, setselectstatus, setSearchArr, setselMonths, setActiveTab, error])
const handleChangemain = React.useCallback((employeeId, rowsInput) => {
  setselectstatus(true);

  // 🔥 rowsInput already contains reviewer1 & reviewer2
  setEmpData(
    rowsInput.map(r => ({
      ...r,
      reviewer1: r.reviewer1 || null,
      reviewer2: r.reviewer2 || null
    }))
  );
}, []);
 

  const handleUpdate =React.useCallback((employee) =>{
    const fetchApi =async()=>{
      await api.appraisal().SaveAppraiseeReviewerSetup(employee.appraiseeId == undefined ? employee.employeeId : employee.appraiseeId,employee.reviewer1,employee.reviewer2);
      setError({ ...error, message: "Appraisal reviewer changed successfully..", status: 200 });
    }
    fetchApi();
  });
  // custome hook.
  const {trow,errorhook,setErrorhook } = useEmployeeListAppraisal(searchArr.length > 0 ? searchArr :(selectedEmp.length ===0  ? (activeTab == '1' ? empData : enabledemployeelist) :selectedEmp), handleSelectedEmp,empArr,handleChangemain,activeTab,handleUpdate,enabledemployeelist,selectedEmp);
  // const {trow1 } = useEnableEmployeeListAppraisal(searchArr.length > 0 ? searchArr :(selectedEmp.length ===0  ? empData :selectedEmp), handleSelectedEmp,empList,handleChangemain);
  const serachEmpList = React.useCallback(
    (searchVal) => {
      setselMonths(searchVal);
      let tempArr = [];
      let newselmoth=[];
      if(selMonths.length > 0)
      {
      newselmoth.push(selMonths);
      }
      newselmoth.push(searchVal);
      if (searchVal !== "") {
        // employee name search..
        // empData.filter((el) =>
        //     el.employeeName !==null ?  (String(el.dueOn).toLowerCase().indexOf(searchVal.toLowerCase()) !==
        //       -1
        //         ? tempArr.includes(el)
        //           ? null
        //           : tempArr.push(el)
        //         : null) : null
        //     );
        const filteredEmpData = empData.filter((el) => {
          if (el.employeeName !== null) {
            const isMatch = newselmoth.some((val) => 
              String(el.dueOn).toLowerCase().includes(val.toLowerCase())
            );
            if (isMatch && !tempArr.includes(el)) {
              tempArr.push(el); // Add to tempArr if it's not already included
              return true; // Include in the filtered array
            }
          }
          return false; // Exclude from the filtered array
        });
            setSearchArr(filteredEmpData);
      }
    });
    const onRemove=(selectedList, removedItem) => {
      
      let tempArr = [];
      let newselmoth=[];
      if(selectedList.length > 0)
      {
        selectedList.map((va) =>{
          newselmoth.push(va.value);
        })
      
      }
     
      if (removedItem !== "") {
        
        const filteredEmpData = empData.filter((el) => {
          if (el.employeeName !== null) {
            const isMatch = newselmoth.some((val) => 
              String(el.dueOn).toLowerCase().includes(val.toLowerCase())
            );
            if (isMatch && !tempArr.includes(el)) {
              tempArr.push(el); // Add to tempArr if it's not already included
              return true; // Include in the filtered array
            }
          }
          return false; // Exclude from the filtered array
        });
            setSearchArr(filteredEmpData);
      }
    }
  return (
    <Fragment>
    {empList.length>0?(      
      <Container>
        <Row>
          <Col>{/* <h3>Assign Rewards</h3> */}</Col>
        </Row>
        <Row className="top-row">
          <Col>
            <Row>
              <Col>
                {" "}
                <h5>Appraisal Enable</h5>
              </Col>
              <Col>
                
              </Col>
            </Row>
            <Row>
              <Col md={6}>
              <Input
                  type="text"
                  className="d-inline"
                  placeholder="Search Employee...."
                  onChange={(e) => searchEmployee(e.target.value)}
                />
              </Col>
              <Col md={6}>
              {/* <Input type="select" onChange={(e) =>
                  serachEmpList(e.target.value)
                }>
                  <option value="Select">All</option>
                  <option value="January" >January</option>
                  <option value="February">February</option>
                  <option value="March">March</option>
                  <option value="April">April</option>
                  <option value="May">May</option>
                  <option value="June">June</option>
                  <option value="July">July</option>
                  <option value="August">August</option>
                  <option value="September">September</option>
                  <option value="October">October</option>
                  <option value="November">November</option>
                  <option value="December">December</option>
                  <option value="0">Not Eligible</option>
                </Input> */}
                <div style={{background : "white"}}>
                 <Multiselect
        options={options} // Options to display in the dropdown
        selectedValues={selectedoptionsList} // Preselected value to persist in dropdown
        onSelect={(e) => {
          serachEmpList(e[e.length-1].value);
        }} // Function will trigger on select event
        onRemove={onRemove} // Function will trigger on remove event
        placeholder="Select Month..." // ✅ Placeholder text
        displayValue="label" // Property name to display in the dropdown options
        style={{
    multiselectContainer: { color: "black" }, // ✅ Ensures text isn’t gray/faded
  }}
  disable={false} // ✅ Ensure it’s not disabled
        /></div>
              </Col>
            </Row>
            <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "1" })}
            onClick={() => {
              toggle("1");
            }}
          >
            Appraisal
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "2" })}
            onClick={() => {
              toggle("2");
            }}
          >
           OnGoing Appraisal
          </NavLink>
        </NavItem>
    
      </Nav>
            <Row>
               <TabContent activeTab={activeTab} className="newtabwidth">
                      <TabPane tabId="1">
                      <Col md={12}>
            <div className="mt-2">
              <TableWithSortPagtn
                thead={thead}
                trow={trow}
                enabledemployeelist={enabledemployeelist}
                pageSize={20}
                
              ></TableWithSortPagtn>
              <div style={{marginLeft:"22px"}}>
              <Label check className="check-select-all">
                <Input type="checkbox" onChange={handleSelectAllEmp} />
                Select All
              </Label>
              </div>
            </div>
            <Button
        // color="danger"
        className="assign-reward-btn-submit float-right"
        onClick = {handleClick}
        // outline
      >
        <i className="far fa-hand-point-up"></i> Enable Appraisal
      </Button>
            </Col>
                      </TabPane>
                </TabContent>
                <TabContent activeTab={activeTab} className="newtabwidth">
                <TabPane tabId="2">
                  {enabledemployeelist.length > 0 ?(<Col md={12}>
                      <div className="mt-2">
              <TableWithSortPagtn
                thead={thead1}
                trow={trow}
                pageSize={20}
              ></TableWithSortPagtn>
              <div style={{marginLeft:"22px"}}>
              <Label check className="check-select-all">
                <Input type="checkbox" onChange={handleSelectAllEmp} />
                Select All
              </Label>
              </div>
            </div>
                      </Col>) : null}    
                </TabPane>
                </TabContent>
            </Row>
          </Col>
        </Row>
        {/* footer  */}
      </Container>
      
    
    ):null}
    {errorhook && <Notifications notifications={errorhook}></Notifications>}
      <Notifications notifications={error}></Notifications>
        <DarkBackground disappear={loaded}>
    <LoadingOverlay
          active={true}
          spinner={true}
          text="Loading your content..."
        >
        </LoadingOverlay>
    </DarkBackground>
    </Fragment>
 
  );
};

AppraisalAssign.prototype = {
  getEmpList: PropTypes.func,
  GetAppraisalEnableList:PropTypes.func
};

const mapStateToProps = (state) => ({
  empList: state.empReducer,
  appraisalEnableList:state.appraisalReducer
});

export default connect(mapStateToProps, {
  getEmpList,
  GetAppraisalEnableList,
  EnableAllAppraisee
})(AppraisalAssign);
